import { defineComponent as _defineComponent } from 'vue';
import AzButtonText from '~/components/_next/atoms/AzButtonText.vue';
import AzRecipeCard from '~/components/_next/molecules/AzRecipeCard.vue';
import MobileFiltersButton from '~/components/ui/CustomStoreFrontUI/MobileFiltersButton.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import AzRadio from '@/components/_next/molecules/AzRadio.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzAccordionItem from '@/components/_next/molecules/AzAccordionItem.vue';
import AzFilter from '@/components/_next/molecules/AzFilter.vue';
import SortSelector from '~/components/ui/SortSelector.vue';
import AzPagination from '~/components/_next/molecules/AzPagination.vue';
import { AisConfigure, AisIndex, AisHits, AisStateResults, AisPagination, AisRefinementList, AisSortBy, AisStats, AisClearRefinements } from 'vue-instantsearch';
import { useUser } from '~/composables/_next/useUser';
import { useAlgoliaSearch } from '~/composables/_next/useAlgoliaSearch';
import { useRecipesWishlists } from '~/composables/useRecipesWishlists';
import useMobileObserver from '~/composables/useMobileObserver';
import useUiState from '~/composables/useUiState';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { z } from 'zod';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchRecipe',
  props: {
    activeTab: {
      type: Boolean
    }
  },
  emits: ['recipeHit'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useAlgoliaSearch = useAlgoliaSearch(),
      indexRecipe = _useAlgoliaSearch.indexRecipe,
      filtersRecipes = _useAlgoliaSearch.filtersRecipes,
      sortsRecipes = _useAlgoliaSearch.sortsRecipes;
    var _useRecipesWishlists = useRecipesWishlists(),
      isInRecipesWishlists = _useRecipesWishlists.isInRecipesWishlists,
      removeRecipeFromWishlist = _useRecipesWishlists.removeRecipeFromWishlist;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useUiState = useUiState(),
      toggleAddRecipeToWishlistSidebar = _useUiState.toggleAddRecipeToWishlistSidebar;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var route = useRoute();
    var router = useRouter();
    var searchQuery = ref('');
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var sidebar = ref(null);
    var aisStateResultsRef = ref(null);
    var pageSchema = z.coerce.number().catch(1);
    var page = computed(function () {
      var parsedPage = pageSchema.parse(route.query.page);
      return parsedPage > 0 ? parsedPage - 1 : 0;
    });
    var query = computed(function () {
      return route.params.term;
    });

    /**
     * Clears the current URL query parameters by pushing an empty query object.
     */
    function clearURL() {
      router.push({
        query: {}
      });
    }

    /**
     * Opens the filters sidebar.
     */
    function openSidebar() {
      var _sidebar$value, _sidebar$value$sideba;
      (_sidebar$value = sidebar.value) === null || _sidebar$value === void 0 ? void 0 : (_sidebar$value$sideba = _sidebar$value.sidebar) === null || _sidebar$value$sideba === void 0 ? void 0 : _sidebar$value$sideba.showModal();
    }

    /**
     * Updates the recipe wishlist based on the user's authentication status.
     * If the user is authenticated, it checks if the recipe is already wishlisted and removes or adds it accordingly.
     * If the user is not authenticated, it redirects to login with the current and previous route path.
     *
     * @param {Object} recipe - The recipe object to update in the wishlist.
     */
    function updateRecipeWishlist(recipe) {
      if (isAuthenticated.value) {
        var wishlisted = isInRecipesWishlists((recipe === null || recipe === void 0 ? void 0 : recipe.recipeId) || (recipe === null || recipe === void 0 ? void 0 : recipe.id));
        if (wishlisted) {
          removeRecipeFromWishlist((recipe === null || recipe === void 0 ? void 0 : recipe.recipeId) || (recipe === null || recipe === void 0 ? void 0 : recipe.id));
        } else {
          toggleAddRecipeToWishlistSidebar({
            contentfulId: (recipe === null || recipe === void 0 ? void 0 : recipe.recipeId) || (recipe === null || recipe === void 0 ? void 0 : recipe.id),
            image: recipe.photo,
            name: recipe.title
          });
        }
      } else {
        navigateToOrLogin({
          nextRoutePath: route.path,
          previousRoutePath: route.path
        });
      }
    }
    watch(function () {
      var _aisStateResultsRef$v, _aisStateResultsRef$v2, _aisStateResultsRef$v3, _aisStateResultsRef$v4;
      return (_aisStateResultsRef$v = aisStateResultsRef.value) === null || _aisStateResultsRef$v === void 0 ? void 0 : (_aisStateResultsRef$v2 = _aisStateResultsRef$v.$data) === null || _aisStateResultsRef$v2 === void 0 ? void 0 : (_aisStateResultsRef$v3 = _aisStateResultsRef$v2.state) === null || _aisStateResultsRef$v3 === void 0 ? void 0 : (_aisStateResultsRef$v4 = _aisStateResultsRef$v3.results) === null || _aisStateResultsRef$v4 === void 0 ? void 0 : _aisStateResultsRef$v4.nbHits;
    }, function (newValue) {
      if (newValue) {
        emit('recipeHit', newValue);
      }
    });
    return {
      __sfc: true,
      emit: emit,
      props: props,
      indexRecipe: indexRecipe,
      filtersRecipes: filtersRecipes,
      sortsRecipes: sortsRecipes,
      isInRecipesWishlists: isInRecipesWishlists,
      removeRecipeFromWishlist: removeRecipeFromWishlist,
      isMobile: isMobile,
      toggleAddRecipeToWishlistSidebar: toggleAddRecipeToWishlistSidebar,
      navigateToOrLogin: navigateToOrLogin,
      route: route,
      router: router,
      searchQuery: searchQuery,
      isAuthenticated: isAuthenticated,
      sidebar: sidebar,
      aisStateResultsRef: aisStateResultsRef,
      pageSchema: pageSchema,
      page: page,
      query: query,
      clearURL: clearURL,
      openSidebar: openSidebar,
      updateRecipeWishlist: updateRecipeWishlist,
      AzButtonText: AzButtonText,
      AzRecipeCard: AzRecipeCard,
      MobileFiltersButton: MobileFiltersButton,
      AzSidebar: AzSidebar,
      AzRadio: AzRadio,
      AzButton: AzButton,
      AzAccordionItem: AzAccordionItem,
      AzFilter: AzFilter,
      SortSelector: SortSelector,
      AzPagination: AzPagination,
      AisConfigure: AisConfigure,
      AisIndex: AisIndex,
      AisHits: AisHits,
      AisStateResults: AisStateResults,
      AisPagination: AisPagination,
      AisRefinementList: AisRefinementList,
      AisSortBy: AisSortBy,
      AisStats: AisStats,
      AisClearRefinements: AisClearRefinements
    };
  }
});